module.exports = [{"type":"flavor","text":"A tourist asks for help hauling some luggage to their taxi.","filters":[{"type":"flag","flag":"has-luggage-job","value":true}],"effects":[{"type":"resource","resource":"yen","value":80}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/luggage-event.json
// module id = 155
// module chunks = 0